
import { useState } from 'react';

export default function Gallery() {
  const galleryItems = [
    {
      image: 'https://public.readdy.ai/ai/img_res/bd53fc00514bc7fd2ffb5197cf946399.jpg',
      title: 'Fine Art Oil Painting',
      description: 'Museum-quality framing with archival matting and custom gold leaf detailing',
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Custom%20framed%20black%20and%20white%20vintage%20family%20photograph%20with%20elegant%20dark%20wood%20frame%20and%20archival%20white%20matting%20classic%20portrait%20framing%20style%20museum-quality%20preservation%20timeless%20design%20professional%20craftsmanship&width=600&height=800&seq=gallery-2&orientation=portrait',
      title: 'Vintage Family Portrait',
      description: 'Preservation framing with acid-free materials and UV-protective glass',
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Sports%20jersey%20professionally%20framed%20in%20deep%20shadow%20box%20frame%20with%20black%20matting%20and%20nameplate%20museum-quality%20display%20case%20memorabilia%20preservation%20clean%20background%20premium%20presentation%20expert%20mounting&width=600&height=800&seq=gallery-7&orientation=portrait',
      title: 'Sports Memorabilia',
      description: 'Custom shadow box with professional mounting and protective display',
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Contemporary%20abstract%20art%20print%20with%20minimalist%20thin%20black%20metal%20frame%20and%20wide%20white%20matting%20modern%20gallery%20style%20framing%20clean%20lines%20sophisticated%20presentation%20museum-quality%20materials%20professional%20finish&width=600&height=800&seq=gallery-8&orientation=portrait',
      title: 'Plexi Framing',
      description: 'Modern minimalist framing with precision-cut matting and sleek profiles',
    },
  ];

  return (
    <section id="portfolio" className="py-24 bg-[#1a1a1a]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="mb-16">
          <h3 className="text-3xl md:text-5xl font-serif font-bold text-white mb-4">Framing Excellence Across Every Piece</h3>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {galleryItems.map((item, index) => (
            <div key={index} className="group">
              <div className="aspect-[3/4] w-full overflow-hidden rounded-lg mb-4">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <h4 className="text-lg font-serif font-bold text-white mb-2">{item.title}</h4>
              <p className="text-white/60 text-sm leading-relaxed">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
